var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerSeagateImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 50,
    viewBox: "0 0 170 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_87_124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 170,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 50,
    fill: "#6FBE4B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_87_124)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2005 7.53451C100.02 12.0765 100.976 15.0475 100.976 17.0965C100.976 17.7454 100.976 19.0431 99.781 18.3601C98.7224 17.7454 96.7417 15.7988 95.8196 13.6815C95.3074 11.8033 95 9.82256 95 8.08091C95 2.37786 97.971 0.43131 102.991 3.33406C109.48 7.05641 115.08 16.3794 115.08 24.4046C115.08 30.3467 112.007 32.0884 107.123 29.2539C102.684 26.6927 98.6199 21.4336 96.6051 16.072C97.6296 17.882 99.5761 20.1359 100.874 20.8872C102.206 21.6726 102.65 20.1359 102.65 18.8382C102.65 18.6333 102.547 17.8137 102.547 17.6429C103.845 21.0921 106.474 24.1997 108.182 25.1559C110.504 26.4878 111.221 24.8827 111.221 22.8337C111.221 17.7112 107.055 10.0958 103.094 7.80771C101.249 6.74906 99.9859 6.98811 99.1663 7.50036L99.2005 7.53451ZM103.094 10.0616C105.177 11.2569 108.694 16.5501 108.694 20.6823C108.694 21.9458 108.284 22.7996 107.294 22.219C105.143 20.9896 101.967 14.1255 101.352 9.85671C101.625 9.20786 102.581 9.75426 103.094 10.0275V10.0616Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3469 39.4536C67 43.1085 67.7619 45.4993 67.7619 47.1482C67.7619 47.6703 67.7619 48.7146 66.8095 48.165C65.966 47.6703 64.3878 46.1039 63.6531 44.4001C63.2449 42.8887 63 41.2948 63 39.8933C63 35.3041 65.3673 33.7377 69.3673 36.0735C74.5374 39.0689 79 46.5711 79 53.029C79 57.8106 76.551 59.2121 72.6599 56.9313C69.1225 54.8702 65.8844 50.6382 64.2789 46.3238C65.0952 47.7802 66.6463 49.5939 67.6803 50.1985C68.7415 50.8306 69.0952 49.5939 69.0952 48.5497C69.0952 48.3848 69.0136 47.7253 69.0136 47.5879C70.0476 50.3634 72.1429 52.8641 73.5034 53.6336C75.3537 54.7053 75.9252 53.4137 75.9252 51.7649C75.9252 47.6428 72.6054 41.5147 69.449 39.6735C67.9796 38.8216 66.9728 39.0139 66.3197 39.4261L66.3469 39.4536ZM69.449 41.4872C71.1088 42.449 73.9116 46.7085 73.9116 50.0336C73.9116 51.0504 73.585 51.7374 72.7959 51.2703C71.0816 50.281 68.551 44.7574 68.0612 41.3223C68.2789 40.8002 69.0408 41.2399 69.449 41.4597V41.4872Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 28.0015L92.3482 38.0074V24.0401L75 14V28.0015Z",
    fill: "#8AE261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2643 26.0208L75 14V28.0015L92.3482 38.0074V24.0401L83.2643 26.0208Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 48.9673L127.348 59.0074V45.0059L110 35V48.9673Z",
    fill: "#8AE261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.264 46.9866L110 35V48.9673L127.348 59.0074V45.0059L118.264 46.9866Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.196 16.8788L141.949 25.3821C146.491 28.0117 150.145 25.2114 150.145 19.1668C150.145 13.1223 146.457 6.12151 141.949 3.49197L127.196 -5.01138C122.654 -7.64093 119 -4.84063 119 1.20392C119 7.24846 122.688 14.2492 127.196 16.8788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.363 22.8209L147.753 35.593L140.104 21.5574L145.363 22.8209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.602 2.84269L142.53 13.1901V10.3557L124.602 0.00823975V2.84269Z",
    fill: "#8AE261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.602 8.61423L142.53 18.9617V16.1272L124.602 5.77979V8.61423Z",
    fill: "#8AE261"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8834 7.6021L71.66 12.6563C74.3578 14.2272 76.5434 12.5538 76.5434 8.9681C76.5434 5.38235 74.3578 1.21605 71.66 -0.354848L62.8834 -5.40905C60.1856 -6.97995 58 -5.30659 58 -1.72085C58 1.8649 60.1856 6.0312 62.8834 7.6021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.675 11.1194L75.1093 18.7348L70.5332 10.3681L73.675 11.1194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2402 -0.42284L73.2952 6.54376V4.63136L61.2402 -2.30109V-0.42284Z",
    fill: "#8AE261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2402 3.47023L73.2952 10.4368V8.52443L61.2402 1.59198V3.47023Z",
    fill: "#8AE261"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 31.6511L53.8419 47.1211V25.5041L27 10V31.6511Z",
    fill: "#8AE261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7721 28.5776L27 10V31.6511L53.8419 47.1211V25.5041L39.7721 28.5776Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_87_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7031 37.9467L25.9822 43.8888C29.124 45.6988 31.6853 43.7864 31.6853 39.5518C31.6853 35.3172 29.124 30.4679 25.9822 28.6238L15.7031 22.6817C12.5613 20.8717 10 22.7841 10 27.0187C10 31.2533 12.5613 36.1026 15.7031 37.9467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3347 42.0789L30.008 50.992L24.6465 41.191L28.3347 42.0789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5879 27.8729L27.3503 35.8298V33.6442L13.5879 25.7214V27.8729Z",
    fill: "#8AE261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5879 32.3122L27.3503 40.2691V38.0835L13.5879 30.1607V32.3122Z",
    fill: "#8AE261"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_87_124",
    x: 95,
    y: 2,
    width: 24.0801,
    height: 28.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_87_124",
    x: 63,
    y: 35,
    width: 20,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_87_124",
    x: 75,
    y: 14,
    width: 21.3477,
    height: 24.0074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_87_124",
    x: 110,
    y: 35,
    width: 21.3477,
    height: 24.0074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_87_124",
    x: 119,
    y: -6,
    width: 35.1445,
    height: 41.593,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_87_124",
    x: 58,
    y: -6,
    width: 22.543,
    height: 24.7349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_87_124",
    x: 27,
    y: 10,
    width: 30.8418,
    height: 37.121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_87_124",
    x: 10,
    y: 22,
    width: 25.6855,
    height: 28.992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_124",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSeagateImg);
export default __webpack_public_path__ + "static/media/banner-seagate-img.9f938f237b68b82def69d26f9b11e636.svg";
export { ForwardRef as ReactComponent };